export enum AnalyticsUserType {
  LAMBDA = 'LAMBDA',
  CITIZEN = 'CITIZEN',
  AGENT = 'AGENT',
  ADMIN = 'ADMIN',
  OFFICER = 'OFFICER',
  MANAGER = 'MANAGER',
  ORGANIZATION = 'ORGANIZATION',
}
